<script setup lang="ts">
import '../../../composables/use-icons';
import useLocale from '../../../composables/useLocale';
import { ref } from 'vue';

const { t } = useLocale();
type Props = {
  label: string;
};

const props = defineProps<Props>();
const expanded = ref(false);
</script>

<template>
  <v-expansion-panel class="bg-surface-container mb-2 mt-0" v-model="expanded">
    <v-expansion-panel-title class="py-2 px-4 rounded" expand-icon="mdi-menu-down" color="primary">
      <template #actions="{ expanded }">
        <v-icon
          class="chevron"
          :class="{ 'chevron--expanded': expanded }"
          icon="fa:fal fa-chevron-down"
          size="x-small"
        />
      </template>
      {{ t(`${props.label}`) }}
    </v-expansion-panel-title>
    <v-expansion-panel-text>
      <slot name="content"></slot>
    </v-expansion-panel-text>
  </v-expansion-panel>
</template>

<style scoped lang="scss">
:deep(.v-expansion-panel__shadow) {
  box-shadow: none;
}
:deep(.v-expansion-panel-text__wrapper) {
  padding: 0;
}
.v-expansion-panel-title {
  min-height: 48px !important;
}
.v-expansion-panel--active > .v-expansion-panel-title {
  min-height: 48px !important;
}
.select-wrapper {
  cursor: pointer;
}
.select-menu {
  max-width: 155px;
}
.select {
  border-radius: 22px;
  :deep(.v-input__append-inner) {
    position: relative;
    left: 16px;
  }
}

.chevron {
  transition: transform 0.25s ease;
}

.chevron--expanded {
  transform: rotate(-180deg);
}
</style>
